import { render, staticRenderFns } from "./ModalPopUpPlanFreeExam.vue?vue&type=template&id=79a93427&scoped=true"
import script from "./ModalPopUpPlanFreeExam.vue?vue&type=script&lang=ts"
export * from "./ModalPopUpPlanFreeExam.vue?vue&type=script&lang=ts"
import style0 from "./ModalPopUpPlanFree.scss?vue&type=style&index=0&id=79a93427&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a93427",
  null
  
)

export default component.exports